import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import StatusChip from "@entrilia/shared/components/StatusChip";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import { Container, Stack, Typography } from "@mui/material";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import CapabilitiesNav from "./CapabilitiesNav";
import CapabilitySection from "./CapabilitySection";
import { capabilities } from "./investorPortalCapabilities";
import PromoBanner from "./PromoBanner";
import TalkToOurTeamButton from "./TalkToOurTeamButton";
import useCapabilityScrollSpy from "./useCapabilityScrollSpy";

const formatCounter = (index: number) =>
  `${String(index + 1).padStart(2, "0")} / ${String(capabilities.length).padStart(2, "0")}`;

const InvestorPortalPromoPage = () => {
  usePageTitle("Investor Portal");

  const { activeKey, handleScroll, selectCapability, registerSection } = useCapabilityScrollSpy();

  return (
    <>
      <GeneralPageHeader
        TitleComponent={
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="h6">Investor Portal</Typography>
            <StatusChip label="Not enabled" color={(t) => t.palette.warning.main} />
          </Stack>
        }
      />
      <ScrollableFlexContainer onScroll={handleScroll}>
        <Container maxWidth="lg" disableGutters sx={{ pt: 3.5, pb: 8 }}>
          <Stack spacing={4.5}>
            <PromoBanner spacious>
              <Stack spacing={1.75} sx={{ flex: "1 1 420px", minWidth: 0 }}>
                <Typography variant="overline" color="primary" sx={{ fontWeight: 700 }}>
                  Investor Portal · Guided Tour
                </Typography>
                <Typography variant="h1" sx={{ maxWidth: 640 }}>
                  See everything your{" "}
                  <Typography component="span" variant="inherit" color="primary">
                    Investor Portal
                  </Typography>{" "}
                  can do.
                </Typography>
                <Typography color="textSecondary" sx={{ maxWidth: 560 }}>
                  A branded, secure home for documents, performance, and communication with your investors. Scroll
                  through the capabilities below — then talk to our team to turn it on for your funds.
                </Typography>
              </Stack>
              <TalkToOurTeamButton />
            </PromoBanner>

            <Stack direction="row" spacing={2.5} sx={{ alignItems: "flex-start" }}>
              <CapabilitiesNav activeKey={activeKey} onSelect={selectCapability} />
              <Stack spacing={3.5} sx={{ flex: 1, minWidth: 0 }}>
                {capabilities.map((capability, index) => (
                  <CapabilitySection
                    key={capability.key}
                    ref={registerSection(capability.key)}
                    capability={capability}
                    counter={formatCounter(index)}
                  />
                ))}
                <PromoBanner>
                  <Typography variant="h6" component="h2">
                    Ready to turn the portal on?
                  </Typography>
                  <TalkToOurTeamButton />
                </PromoBanner>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </ScrollableFlexContainer>
    </>
  );
};

export default InvestorPortalPromoPage;
